import { observer } from 'mobx-react';
import { ReactNode } from 'react';

interface ModalBodyProps {
  className?: string;
  children: ReactNode;
}

function ModalBody({ className, children }: ModalBodyProps) {
  return (
    <div className={className} data-test-modal-body={true}>
      {children}
    </div>
  );
}

export default observer(ModalBody);
